import { AsyncPipe, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconModule } from '@spartacus/storefront';
import { PrePaymentComponent } from './prepayment.component';

@NgModule({
  imports: [NgIf, AsyncPipe, IconModule],
  declarations: [PrePaymentComponent],
  exports: [PrePaymentComponent],
})
export class PrePaymentModule {}
